import {
  AccountLockingInfo,
  useAccountLockingSubscription,
} from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';

export function AccountLockingEventsSubscription() {
  const accountId = useActiveAccountId();

  useAccountLockingSubscription({
    variables: { scope: { lock: { accountId } } },
    skip: !accountId,
    onData: ({ client: { cache }, data: { data: result } }) => {
      const { lockedAt = null, lockReason = null } =
        result?.account?.account || {};

      cache.updateFragment(
        {
          id: cache.identify({ __typename: 'Account', id: accountId }),
          fragment: AccountLockingInfo,
          fragmentName: 'AccountLockingInfo',
        },
        (previousData) => {
          if (!previousData) return null;
          return { ...previousData, lockedAt, lockReason };
        }
      );
    },
  });

  return null;
}
